export const HERO = {
  EYEBROW: 'A bite-sized dungeon crawler',
  TITLE: 'Grimtile',
  TAGLINE: 'Descend. Loot. Survive.',
  DESCRIPTION: [
    'Every floor is a mystery.',
    'Reveal the door and push deeper, if you dare.',
  ],
  IOS_APP_STORE_URL: 'https://apps.apple.com/us/app/grimtile/id6793845615?itscg=30200&itsct=apps_box_badge&mttnsubad=6793845615',
  IOS_BADGE_IMAGE_URL: '/stores/apple.svg',
  ANDROID_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.mutopilabs.crawler&pcampaignid=web_badge',
  ANDROID_BADGE_IMAGE_URL: '/stores/google.svg',
}
